import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('Division?page=' + page,  {params});
    }, 
    show(id) {
        return Service().get('Division/show/'+id);
    },    
    create(params) {
        return Service().post('Division/create', params);
    },
    update(id, params) {
        return Service().post('Division/update/'+id, params);
    },
    delete(id) {
        return Service().post('Division/delete/'+id);
    }
}